// Importing necessary utilities and URLs
import { get } from "./httpClient"; // HTTP client for making GET requests
import { LOGIN_URL, LOGIN_OTP_URL, COUNTRY_CODE_URL } from "../Uintls/Urls"; // API endpoints

// Action to handle login
export const loginAction = (payload, successCallback, failureCallback) => async () => {
  try {
    // Making GET API call to login endpoint
    const data = await get(LOGIN_URL, payload);

    // Calling success callback if provided
    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    // Calling failure callback if provided
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to handle OTP retrieval
export const getOtpAction = (payload, successCallback, failureCallback) => async () => {
  try {
    // Making GET API call to OTP endpoint
    const data = await get(LOGIN_OTP_URL, payload);

    // Calling success callback if provided
    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    // Calling failure callback if provided
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};

// Action to fetch the list of countries
export const getCountryList = (successCallback, failureCallback) => async () => {
  try {
    // Making GET API call to country code endpoint
    const data = await get(COUNTRY_CODE_URL);

    // Calling success callback if provided
    if (typeof successCallback === "function") {
      successCallback(data);
    }
  } catch (err) {
    // Calling failure callback if provided
    if (typeof failureCallback === "function") {
      failureCallback(err);
    }
  }
};
